/**
 * MED-1365 QA round 4: the line under the reschedule button. A booking that
 * Medley made as a Google Calendar invite (scheduling_method
 * 'calendly_fallback') moves: Medley changes the time on the same invite. A
 * Calendly booking is canceled, and a new invite is sent.
 */
export function rescheduleConfirmText(
  what: 'session' | 'check-in',
  schedulingMethod: string | null | undefined,
  coachName: string
): string {
  if (schedulingMethod === 'calendly_fallback') {
    return 'Your calendar invite will move to the new time.';
  }
  return `Your existing ${what} will be canceled and a new invite sent to you and ${coachName}.`;
}
